import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Preloader from "./Include/PreLoader";
import API_URL from "../functions/config";

const VerifyEmail = () => {

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const navigate = useNavigate();

    useEffect(() => {

        const verifyEmail = async () => {

            try {

                const params = new URLSearchParams(
                    window.location.search
                );

                const token = params.get("token");

                if (!token) {

                    setError(
                        "Verification token is missing"
                    );

                    setLoading(false);

                    return;
                }

                const response = await fetch(
                    `${API_URL}/verify-email?token=${encodeURIComponent(token)}`
                );

                const result = await response.json();

                if (!response.ok) {

                    setError(
                        result.message ||
                        "Email verification failed"
                    );

                    return;
                }

                setMessage(
                    result.message ||
                    "Email verified successfully"
                );

            } catch (error) {

                console.error(
                    "Verification Error:",
                    error
                );

                setError(
                    "Unable to connect to server"
                );

            } finally {

                setLoading(false);

            }

        };

        verifyEmail();

    }, []);


    return (

        <div className="container">

            <div className="row justify-content-center">

                <div className="col-md-6">

                    <div className="card mt-5">

                        <div className="card-body text-center">

                            {loading && (
                                <Preloader show={loading} />
                            )}


                            {!loading && message && (

                                <>
                                    <div className="alert alert-success">
                                        ✓ {message}
                                    </div>

                                    <button
                                        className="btn btn-success"
                                        onClick={() =>
                                            navigate("/login")
                                        }
                                    >
                                        Go to Login
                                    </button>
                                </>

                            )}


                            {!loading && error && (

                                <>
                                    <div className="alert alert-danger">
                                        {error}
                                    </div>

                                    <button
                                        className="btn btn-primary"
                                        onClick={() =>
                                            navigate("/login")
                                        }
                                    >
                                        Go to Login
                                    </button>
                                </>

                            )}

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

};

export default VerifyEmail;